import { fromJS } from 'immutable';

export const visibleColumns = fromJS([
  'num',
  'newNum',
  'name',
  'location',
  'country',
  'latitude',
  'longitude',
  'elevation',
  'morphology',
  'status',
  'timeErupt',
]);

export const sort = fromJS([
  { id: 'location', asc: true },
  { id: 'country', asc: true },
  { id: 'name', asc: true },
]);

export const minColumns = fromJS([]);
